import { render, staticRenderFns } from "./template001.vue?vue&type=template&id=fa9b444a&scoped=true"
import script from "./template001.vue?vue&type=script&lang=js"
export * from "./template001.vue?vue&type=script&lang=js"
import style0 from "./template001.vue?vue&type=style&index=0&id=fa9b444a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa9b444a",
  null
  
)

export default component.exports